import WindowsInRowFormGeneralInformation from "./WindowsInRowFormGeneralInformation";

export default WindowsInRowFormGeneralInformation;